// src/admin_module/components/plans/googlePlanService.js

import axios from "axios";
import { getToken } from "../../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL, // should already contain /api
  headers: {
    Authorization: `Bearer ${getToken()}`,
    "Content-Type": "application/json",
  },
});

/**
 * ===============================
 * Fetch all Google Plans by Subscription Plan ID
 * ===============================
 */
export const fetchGooglePlansByPlanId = (planId) =>
  api.get(`/admin/play-billing-products/by-plan/${planId}`);

/**
 * ===============================
 * Fetch Single Google Plan by ID
 * ===============================
 */
export const fetchGooglePlanById = (id) =>
  api.get(`/admin/play-billing-products/${id}`);

/**
 * ===============================
 * Create Google Plan
 * Backend expects planId inside request body
 * ===============================
 */
export const createGooglePlan = (planId, data) =>
  api.post(`/admin/play-billing-products`, {
    planId,
    productId: data.productId,
    basePlanId: data.basePlanId,
    offerId: data.offerId || null,
  });

/**
 * ===============================
 * Update Google Plan
 * ===============================
 */
export const updateGooglePlan = (id, data) =>
  api.put(`/admin/play-billing-products/${id}`, {
    productId: data.productId,
    basePlanId: data.basePlanId,
    offerId: data.offerId || null,
  });

/**
 * ===============================
 * Toggle Active / Inactive
 * ===============================
 */
export const toggleGooglePlanStatus = (id, active) =>
  api.patch(
    `/admin/play-billing-products/${id}/status`,
    null,
    {
      params: { active },
    }
  );

/**
 * ===============================
 * Delete Google Plan
 * ===============================
 */
export const deleteGooglePlan = (id) =>
  api.delete(`/admin/play-billing-products/${id}`);